// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallHistoryTable_tableRow__JlvPU {
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.7rem;
}
.CallHistoryTable_tableRow__JlvPU:hover {
  background-color: var(--mantine-color-gray-0);
}

.CallHistoryTable_value__d-2Yf {
  font-size: 0.7rem;
}

.CallHistoryTable_header__RZzQC {
  margin-bottom: 1rem;
  margin-top: 1rem;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid var(--border-color);
  padding: 0.5rem 0;
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--bg-color);
}

.CallHistoryTable_card__lrCDi {
  transition: transform 0.2s;
  background-color: var(--mantine-color-white);
}
.CallHistoryTable_card__lrCDi:hover {
  transform: translateX(4px);
}

.CallHistoryTable_phoneNumber__waS4g {
  font-family: var(--mantine-font-family-monospace);
}

@media screen and (min-width: 75em) {
  .CallHistoryTable_tableRow__JlvPU {
    display: table-row;
    font-size: 0.875rem;
  }
  .CallHistoryTable_value__d-2Yf {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/components/CallHistoryTable/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iCAAA;EACA,iBAAA;AACF;AACE;EACE,6CAAA;AACJ;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,4CAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iCAAA;AAAF;;AAGA;EACE,0BAAA;EACA,4CAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;;AAIA;EACE,iDAAA;AADF;;AAIA;EACE;IACE,kBAAA;IACA,mBAAA;EADF;EAIA;IACE,mBAAA;EAFF;AACF","sourcesContent":[".tableRow {\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 0.7rem;\n\n  &:hover {\n    background-color: var(--mantine-color-gray-0);\n  }\n}\n\n.value {\n  font-size: 0.7rem;\n}\n\n.header {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid var(--border-color);\n  padding: 0.5rem 0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: var(--bg-color);\n}\n\n.card {\n  transition: transform 0.2s;\n  background-color: var(--mantine-color-white);\n\n  &:hover {\n    transform: translateX(4px);\n  }\n}\n\n.phoneNumber {\n  font-family: var(--mantine-font-family-monospace);\n}\n\n@media screen and (min-width: 75em) {\n  .tableRow {\n    display: table-row;\n    font-size: 0.875rem;\n  }\n\n  .value {\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableRow": `CallHistoryTable_tableRow__JlvPU`,
	"value": `CallHistoryTable_value__d-2Yf`,
	"header": `CallHistoryTable_header__RZzQC`,
	"card": `CallHistoryTable_card__lrCDi`,
	"phoneNumber": `CallHistoryTable_phoneNumber__waS4g`
};
export default ___CSS_LOADER_EXPORT___;
